<template>
  <div class="savePoster">
    <div class="savePoster-poster" ref="posterContainer">
      <swiper
        ref="mySwiper"
        v-if="posterListStore.length || posterList.length === defaultList.length + 1"
        class="savePoster-swiper"
        :options="swiperOption"
      >
        <template v-for="(item, idx) in posterList">
          <!-- <a :href="preview" download="kkk.png" :key="idx+'222'">下载</a> -->
          <swiper-slide v-if="item" :key="idx">
            <div class="savePoster-choose">
              <img :src="item.img" :data-poster="item.id" />
            </div>
          </swiper-slide>
          <!-- 上传：制作个性海报 -->
          <swiper-slide v-else :key="idx">
            <div class="savePoster-choose">
              <div class="savePoster-choose-con">
                <img :src="srcIndividuation" alt />
                <PhotoUploader
                  v-if="posterActiveIndex === 2"
                  class="savePoster-uploader"
                  ref="photoUploader"
                  @afterUploader="afterUploader"
                ></PhotoUploader>
              </div>
            </div>
          </swiper-slide>
        </template>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div v-if="posterActiveIndex === 2" :class="['savePoster-create','savePoster-diyPoster', isFinishing?'savePoster-diyPoster-finish':'']" @click="uploadPosterImg">{{isFinishing?'活动已结束':''}}</div>
    <div v-else-if='isApp || isFinishing' :class="['savePoster-create', isFinishing?'savePoster-create-finish':'']" @click="sharePoster(0)">{{isFinishing?'活动已结束':''}}</div>
    <LongpressShare v-else @copyInviteMsg="copyInviteMsg"></LongpressShare>
    <template v-if="defaultList.length && isNeedDraw">
      <PosterPaint
        v-for="(item, idx) in defaultList"
        :key="idx"
        class="savePoster-createPoster"
        :id="idx"
        :type="item.styleType"
        :materiel="item.materiel"
        :poster-id="`${item.posterId}`"
        @posterDrawed="handlePosterDrawed"
      />
    </template>
    <!-- 预览图片弹窗 -->
    <van-popup v-model="isPreview" class="x-van-popup savePoster-preview-popup">
      <img
        @click="closePreview()"
        class="close-preview"
        src="../assets/images/v4.0/close-preview.png"
        alt
      />
      <img class="savePoster-preview" :src="preview" alt />
      <div v-if="isApp || isFinishing" :class="['preview-share-btn', isFinishing?'preview-share-btn-finish':'']" @click="sharePoster(1)">{{isFinishing ?'活动已结束':'分享海报到朋友圈'}}</div>
      <LongpressShare v-else @copyInviteMsg="copyInviteMsg"></LongpressShare>
    </van-popup>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import Clipboard from '../utils/clipBoard'
import { mapActions, mapState } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import PosterPaint from '@/inviteAutumn/components/PosterPaint' // 海报生成
import PhotoUploader from '@/inviteAutumn/components/PhotoUploader'
import LongpressShare from '@/inviteAutumn/components/LongpressShare.vue'

export default {
  name: 'savePoster',
  computed: {
    ...mapState([
      'posterListStore',
      'defaultPoster',
      'qualification',
      'sourceId',
      'isFinishing'
    ]),
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    posterContainer () {
      return this.$refs.posterContainer
    }
  },
  components: { swiper, swiperSlide, PosterPaint, PhotoUploader, LongpressShare },
  data () {
    // eslint-disable-next-line
    const _that = this
    return {
      preview: '',
      isPreview: false, // 是否展示预览
      srcIndividuation:
        'https://activity.xueersi.com/oss/ldxv4/1125_default.png',
      posterLength: 0,
      studentData: '',
      defaultList: [],
      userInfo: {},
      learningData: {},
      posterList: [], // 合成的默认海报 地址
      temPosterList: [],
      posterActiveIndex: 0,
      isApp: /jzh$/i.test(navigator.userAgent), // 是否是原生app
      swiperOption: {
        loop: true,
        isLongPress: false, // 用户是否触发长按事件
        centeredSlides: true,
        slidesPerView: 'auto',
        pagination: { el: '.swiper-pagination' },
        // 监听swiper的滑动操作
        on: {
          slideChange: function () {
            const activeIndex = this.realIndex
            _that.posterActiveIndex = activeIndex
            _that.posterShowLog(activeIndex)
          },
          click: function () {
            const activeIndex = this.realIndex
            _that.previewImg(activeIndex)
          }
        }
      },
      isNeedDraw: false,
      firstPosterId: -1, // 第一张（C位）海报ID
      disable: true
    }
  },
  created () {
    // 获取海报
    this.disable = true
    this.getPosterList()
  },
  methods: {
    ...mapActions([
      'storePosterResult',
      'storeDefaultPoster',
      'storeUploadImg'
    ]),
    // 符合条件时执行
    successHandle (temArr, item) {
      const {
        ldx_poster_finish_num,
        ldx_poster_avg_rate,
        ldx_poster_study_days
      } = this.learningData
      // 如果后端数据没有返回则打入日志
      if (!item.img) {
        this.$xesLogger.clickMsg({
          params: {
            src: '后端接口没有返回img字段',
            type: JSON.stringify(item),
            action: 'getImgError'
          }
        })
      }
      item.materiel = {
        bgImg: item.img,
        qrCode:
          item.qrCode ||
          'https://activity.xueersi.com/oss/ldxv4_1127/qrcode.jpeg',
        nick: this.userInfo.nickName || '',
        avatar: this.userInfo.avatar || '',
        answerCount: ldx_poster_finish_num || '', // 累计答题数量
        rightRate: ldx_poster_avg_rate || '', // 正确率
        studyDays: ldx_poster_study_days || '', // 累计学习天数
        isQrCode: item.isQrCode || 0 // 是否需要前端生成二维码
      }
      // 如果需要前端生成二维码，则进行url拼接，用于生成二维码
      if (item.isQrCode) {
        // const tempUrl = item.qrCode
        item.materiel.qrCode = this.getQrCodeUrl(item)
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'show',
            element_value: '首页海报-首页单张海报将要绘制',
            posterId: item.posterId,
            posterType: item.posterType,
            firstPosterId: this.firstPosterId,
            isQrCode: item.isQrCode
          }
        })
      } else {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'show',
            element_value: '首页海报-首页单张海报将要绘制',
            posterId: item.posterId,
            posterType: item.posterType,
            firstPosterId: this.firstPosterId,
            isQrCode: item.isQrCode
          }
        })
      }
      // 正确率位数处理。对于>4位数的字符串，小于100%，取4位；其它，取3位
      if (item.materiel.rightRate.length > 4) {
        if (Number(item.materiel.rightRate) < 1) {
          item.materiel.rightRate = item.materiel.rightRate.slice(0, 3)
        } else {
          item.materiel.rightRate = item.materiel.rightRate.slice(0, 2)
        }
      }
      temArr.push(item)
    },
    // 处理单一数据时的操作
    errorHandler () {
      this.$toast('获取海报信息异常，请重新登录尝试～')
      this.posterList = []
      this.storePosterResult(this.posterList)
      this.$nextTick(() => {
        // 海报默认图
        this.posterList = [
          {
            id: 0,
            img: 'https://activity.xueersi.com/oss/ldxv4_1127/default01.png' // 默认图
          }
        ]
        this.defaultList = [
          {
            posterType: -1,
            posterId: -1,
            subject: -1,
            qrCode: '',
            shareDesc:
              '孩子说在学而思课堂学到了许多又快又好的解题方法，开阔了思路，拓展了思维。短短半个月，进步很大，推荐给大家，一起学习，共同进步！扫我的码，可以免费听课。',
            img: 'https://activity.xueersi.com/oss/ldxv4_1127/default01.png',
            styleType: 1,
            curTime: new Date().valueOf() / 1000
          }
        ]
        this.storePosterResult(this.posterList)
        this.$set(this.swiperOption, 'loop', false)
        this.$nextTick(() => {
          this.disable = false
        })
      })
    },
    // 判断累计答题数量、正确率、累计学习天数是否符合条件
    isJudge (n) {
      return !!(n === 0 || n)
    },
    // 获取拼接用户及海报信息后的二维码地址
    getQrCodeUrl (item) {
      let result = ''
      if (item.jumpUrl.indexOf('?') !== -1) {
        result = item.jumpUrl + '&'
      } else {
        result = item.jumpUrl + '?'
      }
      result =
        result +
        'userId=' +
        (this.userInfo.tagId || '') +
        '&posterId=' +
        item.posterId +
        '&sourceId=' +
        (this.sourceId || '') +
        '&sgroupId=' +
        '20043'
      return result
    },
    // 获取海报数据
    getPosterList () {
      if (this.posterListStore.length && this.defaultPoster.length) {
        this.defaultList = this.defaultPoster
        this.posterList = this.posterListStore
        this.isNeedDraw = false
        this.disable = false
        return
      } else {
        this.isNeedDraw = true
      }
      // 默认3张占位图
      this.posterList = []
      for (let i = 0; i < 3; i++) {
        this.posterList.push({
          id: i,
          img: 'https://activity.xueersi.com/oss/ldxv4/1125_no_data.png' // 占位图
        })
      }
      this.storePosterResult(this.posterList)
      console.log('RSTART--------', new Date().valueOf())
      // this.$toast.loading({
      //   forbidClick: true,
      //   duration: 0,
      //   message: '生成中...'
      // })
      // 获取非个性化海报数据
      this.$api
        .posterList({ posterCode: 'NOPERSON', sourceId: this.sourceId })
        .then(res => {
          console.log('REND--------', new Date().valueOf())
          if (res.code !== 0) return this.errorHandler()
          this.$set(this.swiperOption, 'loop', true)
          // this.$toast.clear()
          // const temArr = [];
          let { posters, user, learningData } = res.data
          if (!learningData) {
            learningData = {
              // ldx_poster_finish_num: '123',
              // ldx_poster_study_days: '456',
              // ldx_poster_avg_rate: '90'
            }
          }
          console.log('posters=>>', posters)
          if (!user) user = {}
          if (!posters) {
            this.dataFalse = true
            this.$toast('暂无可用数据')
            this.posterList = ['']
            this.$set(this.swiperOption, 'loop', true)
            return
          } else {
            this.userInfo = user
            this.learningData = learningData
            this.posterList = []
            const temArr = []
            console.log('=====?', posters)
            posters.map((item, index) => {
              this.$xesLogger.clickMsg({
                params: {
                  action: 'posters-filter',
                  materiel: JSON.stringify(item)
                }
              })
              // 存储第一张海报（C位）ID
              if (index === 0) this.firstPosterId = item.posterId
              // 首先填充海报占位图
              this.posterList.push({
                id: index,
                img: 'https://activity.xueersi.com/oss/ldxv4/1125_no_data.png' // 占位图
              })
              // 个性化海报入口位置
              if (index === 1) this.posterList.push('')
            })
            this.defaultList = posters.filter(item => {
              /*
          // 字段含义示例：
          // ldx_poster_finish_num 累计答题数量
          // ldx_poster_avg_rate 正确率
          // ldx_poster_study_days 累计学习天数
        */
              const { styleType } = item
              if (
                Boolean(this.learningData) === false &&
                styleType >= 4 &&
                styleType <= 6
              ) {
                return false
              }
              const {
                ldx_poster_finish_num,
                ldx_poster_avg_rate,
                ldx_poster_study_days
              } = this.learningData
              // 限制条件：
              // 1.不存在学习数据，所有数据海报都不展示；
              // 2.针对数据海报（样式类型：4、5），如果有一条数据没有，则不展示，但数据为0时需要展示
              // 3.海报5，如果正确率小于80%，则不展示。
              if (styleType === 4 || styleType === 6) {
                if (
                  this.isJudge(ldx_poster_finish_num) &&
                  this.isJudge(ldx_poster_study_days)
                ) {
                  this.successHandle(temArr, item)
                  return true
                }
              } else if (styleType === 5) {
                if (
                  this.isJudge(ldx_poster_finish_num) &&
                  this.isJudge(ldx_poster_study_days) &&
                  (ldx_poster_avg_rate === '0' || ldx_poster_avg_rate >= 80)
                ) {
                  this.successHandle(temArr, item)
                  return true
                }
              } else {
                this.successHandle(temArr, item)
                return true
              }

              // if (
              //   (((!ldx_poster_finish_num && ldx_poster_finish_num !== 0) ||
              //     (!ldx_poster_avg_rate && ldx_poster_avg_rate !== 0) ||
              //     Number(ldx_poster_avg_rate) < 80 ||
              //     (!ldx_poster_study_days && ldx_poster_study_days !== 0)) &&
              //     item.styleType === 5) ||
              //   (((!ldx_poster_finish_num && ldx_poster_finish_num !== 0) ||
              //     (!ldx_poster_study_days && ldx_poster_study_days !== 0)) &&
              //     (item.styleType === 4 || item.styleType === 6))
              // ) {
              //   /*

              // */
              //   return false;
              // } else {
              //   this.successHandle(temArr, item);
              //   return true;
              // }
            })
            console.log('====this.defaultList', this.defaultList, temArr)
            this.temPosterList = temArr
            this.storeDefaultPoster(this.defaultList)
          }
          this.$toast.clear()
          // this.posterList = [{ id: 0, img: posters[0].img }]
          this.$set(this.swiperOption, 'loop', true)
        })
        .catch(() => {
          this.errorHandler()
        })
    },
    closePreview () {
      this.isPreview = false
    },
    previewImg (idx) {
      if (idx === 2) {
        // 上传截图
        this.uploadPosterImg()
        return
      }
      this.isPreview = true
      this.preview = this.posterList[idx].img
    },
    // 活动已结束判断
    testIsFinishing () {
      if (this.isFinishing) {
        this.$toast('活动已结束')
        return true
      } else {
        return false
      }
    },
    sharePoster (flag) {
      // 活动已结束判断
      if (this.testIsFinishing()) {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'click',
            element_value: '首页海报-提示-活动已结束-sharePoster-' + flag
          }
        })
        return
      }
      // 海报是否可分享（已加载完则可以分享）
      if (this.disable) {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'click',
            element_value: '首页海报-提示-加载完成图片之后才可以分享哦',
            firstPosterId: this.firstPosterId
          }
        })
        this.$toast('加载完成图片之后才可以分享哦~')
        return
      }
      if (!this.qualification) {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'click',
            element_value: '“分享海报到朋友圈”按钮点击toast提示无资格-出现',
            firstPosterId: this.firstPosterId
          }
        })
        this.$toast('只有同步课在读用户才能参加活动哦~')
        return
      }
      if (!this.isApp) {
        this.$toast('请在APP内使用分享功能')
        return
      }
      let idx = this.posterActiveIndex
      console.log('idx--------', idx, this.defaultList)
      if (idx > 2) {
        idx = idx - 1
      }
      // idx = idx - 1
      this.$xesLogger.clickMsg({
        params: {
          elementname: '首页海报',
          element_action: 'click',
          element_value:
            flag === 1
              ? '首页-预览海报-分享海报到朋友圈按钮-点击'
              : '“分享海报到朋友圈”按钮-点击',
          posterId: this.defaultList[idx].posterId,
          posterType: this.defaultList[idx].posterType,
          firstPosterId: this.firstPosterId
        }
      })
      this.copyInviteMsg()
      const appShareConfig = {
        agentKey: '', // 项目日志自定义统计key
        shareType: 2, // 1.网页，2大图，3小程序
        businessId: 2018, // 项目对于业务ID
        shareScence: 2, // 分享渠道,二进制转换 000000 ~ 111111，  2.朋友圈
        isOneKeyShare: true, // 是否一键分享
        imagePath: this.posterList[this.posterActiveIndex].img, // 大图网络路径
        title: '好友邀你上名师课，购课立减200元！', // 分享标题
        desc: '清北哈佛毕业名师，十余年教学经验，让孩子每天进步一点点！' // 分享描述
      }
      xesApp.appShareBack = res => {
        console.log('分享成功后的回调', res)
        this.$emit('shareSuccess') // 分享成功，通知主页
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'click',
            element_value: '非个性化海报-朋友圈分享回调',
            firstPosterId: this.firstPosterId
          }
        })
      }
      setTimeout(() => {
        xesApp.start(
          'xesShare/share',
          JSON.stringify(appShareConfig),
          'xesApp.appShareBack'
        )
      }, 2000)
    },
    // 复制分享语
    copyInviteMsg () {
      let idx = this.posterActiveIndex
      if (idx > 2) {
        idx = idx - 1
      }
      const copyResult = Clipboard.copy(this.defaultList[idx].shareDesc)
      const messageTips = copyResult
        ? '复制成功，快去邀请好友吧！'
        : '当前环境不支持，请通过海报分享'
      return this.$toast(messageTips)
    },
    // 开始制作专属海报按钮 点击。通过触发 图片/拍照 按钮的点击事件 完成功能。
    uploadPosterImg () {
      // 活动已结束判断
      if (this.testIsFinishing()) {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'click',
            element_value: '首页海报-提示-活动已结束-uploadPosterImg'
          }
        })
        return
      }
      if (!this.qualification) {
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'click',
            element_value: '“分享海报到朋友圈”按钮点击toast提示无资格-出现'
          }
        })
        this.$toast('只有同步课在读用户才能参加活动哦~')
        return
      }
      this.$xesLogger.clickMsg({
        params: {
          elementname: '首页海报',
          element_action: 'click',
          element_value: '“制作专属海报”-按钮点击'
        }
      })
      console.log('click----', this.$refs.photoUploader[0])
      this.$refs.photoUploader[0].$refs.input.click()
    },
    // 海报绘制完成
    handlePosterDrawed (id, posterId, img) {
      const { posterLength } = this
      this.posterLength = posterLength + 1
      this.temPosterList[id] = { id: posterId, img }
      this.$xesLogger.clickMsg({
        params: {
          elementname: '首页海报',
          element_action: 'show',
          element_value: '首页海报-首页单张海报绘制完成',
          posterId: this.defaultList[id].posterId,
          posterType: this.defaultList[id].posterType,
          firstPosterId: this.firstPosterId,
          isQrCode: this.defaultList[id].isQrCode
        }
      })
      console.log('temPosterList=====', this.temPosterList)
      // 单张绘制start
      // if (id > 1) {
      //   id++
      // }
      // this.posterList[id] = { id: posterId, img }
      // this.$nextTick(() => {
      //   this.$emit('bottomBtn')
      //   this.posterList[id] = { id: posterId, img }
      //   this.storePosterResult(this.posterList)
      // })
      // 单张绘制end
      if (this.posterLength >= this.defaultList.length) {
        this.posterShowLog(0) // 海报曝光埋点上报
        this.$xesLogger.clickMsg({
          params: {
            elementname: '首页海报',
            element_action: 'show',
            element_value: '首页海报-首页海报绘制完成',
            firstPosterId: this.firstPosterId
          }
        })
        this.$nextTick(() => {
          this.disable = false
        })
        this.isNeedDraw = false
        console.log('temPosterList----', this.temPosterList)
        const temArr = []
        this.$toast.clear()
        this.temPosterList.forEach((item, idx) => {
          temArr.push(item)
          if (idx === 1) {
            temArr.push('')
          }
        })
        // this.posterList = temArr
        // console.log('posterList----', this.posterList)
        // this.storePosterResult(temArr)
        this.posterList = []
        this.storePosterResult(this.posterList)
        this.$nextTick(() => {
          this.$emit('bottomBtn')
          this.posterList = temArr
          // this.swiper.update()
          console.log('posterList----', this.posterList)
          this.storePosterResult(temArr)
        })
      }
    },
    // 制作个性海报，图片上传完成  字组件事件
    afterUploader (file) {
      // 把用户上传的图片资源 传递到posterList
      // sessionStorage.setItem('uploadImg', file)
      this.storeUploadImg(file)
      this.$router.push({ name: 'posterList' })
    },
    // 海报曝光埋点上报
    posterShowLog (idx) {
      if (idx === 2) {
        return
      } else if (idx > 2) {
        idx--
      }
      this.$xesLogger.clickMsg({
        params: {
          elementname: '首页海报',
          element_action: 'show',
          element_value: '首页海报-海报曝光',
          posterId: this.defaultList[idx].posterId || '',
          posterType: this.defaultList[idx].posterType || '',
          firstPosterId: this.firstPosterId
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.savePoster {
  width: 100%;
  min-height: 30vh;
  padding-bottom: 2px;
  background-size: cover;

  .savePoster-poster {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 30vh;

    .swiper-container {
      width: 100%;
      padding-bottom: 40px;
      margin-top: 20px; // 给  一键复制邀请语 留位置
      .swiper-slide {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 200px;
        font-size: 18px;
        text-align: center;
        transition: 200ms;

        &:not(.swiper-slide-active) {
          opacity: 0.6;
          transform: scale(0.85);
        }
      }
    }

    .savePoster-swiper {
      .savePoster-choose {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border-radius: 8px;

        .savePoster-choose-con {
          .savePoster-uploader {
            position: absolute;
            top: 0;
            display: block !important; // 组件内是inline-block
            width: 0;
            height: 0;
          }
        }
      }
    }
  }

  .savePoster-create {
    width: 281px;
    height: 42px;
    margin: 5px auto 0;
    font-size: 18px;
    font-weight: bolder;
    line-height: 42px;
    text-align: center;
    color: #fff;
    background: url('../assets/images/v4.0/share-btn.png') no-repeat center;
    background-size: 100% 100%;
    border-radius: 35px;

    &.savePoster-create-finish {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #fff;
      background-image: linear-gradient(#ddd, #bcbcbc);
    }

    &.savePoster-diyPoster {
      background: url('../assets/images/v4.0/create-poster.png') no-repeat
        center;
      background-size: 100% 100%;
    }

    &.savePoster-diyPoster-finish {
      background: #fff;
      background-image: linear-gradient(#ddd, #bcbcbc);
    }
  }

  .savePoster-createPoster {
    position: absolute;
    top: 0;
    left: -500%;
    display: block !important; // 组件内是inline-block
    width: 100%;
    height: 100%;

    img {
      vertical-align: middle;
    }
  }

  .savePoster-preview-popup {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 85vw;
    background: #fff0;

    img {
      border-radius: 5px;
    }

    .close-preview {
      position: absolute;
      top: 5px;
      right: 5px;
      width: 24px;
      height: 24px;
      opacity: 0.8;
    }

    .preview-share-btn {
      width: 250px;
      height: 40px;
      margin: 20px;
      font-size: 18px;
      line-height: 40px;
      color: #fff;
      background-image: linear-gradient(#e02727, #ff4330);
      border-radius: 20px;

      &.preview-share-btn-finish {
        background-image: linear-gradient(#ddd, #bcbcbc);
      }
    }
  }
}
</style>
